// The environment, from the admin's host name: prod, dev, local, or the host.
export const environmentOf = host => {
  const h = String(host || '').toLowerCase().replace(/:\d+$/, '')
  if (!h) return 'unknown'
  if (h === 'localhost' || h === '::1' || h === '[::1]' || /^127\./.test(h) || h.endsWith('.localhost') || h.endsWith('.local')) return 'local'
  if (/(^|[.-])dev([.-]|$)/.test(h)) return 'dev'
  if (h === 'admin.educationxr.com') return 'prod'
  return `unknown (${h})`
}
